import FindWeatherLocationsResponse from 'owa-service/lib/contract/FindWeatherLocationsResponse';
import findWeatherLocationsOperation from 'owa-service/lib/operation/findWeatherLocationsOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

/**
 * Makes the call to the server to find a weather location based on the provided query string
 * @returns promise of FindWeatherLocationsResponse type
 */
export default function findWeatherLocationsService(
    searchString: string
): Promise<FindWeatherLocationsResponse> {
    return findWeatherLocationsOperation({
        Header: getJsonRequestHeader(),
        Body: {
            SearchString: searchString,
        },
    }).then(response => {
        if (response && response.Body && !response.Body.ErrorMessage) {
            return response.Body;
        } else {
            throw new Error(`findWeatherLocationsOperation ${response.Body.ErrorMessage}`);
        }
    });
}
